export const UPDATE_REQUEST_VALUE = "UPDATE_REQUEST_VALUE"
export const GET_GAME_DETAIL = "GET_GAME_DETAIL"
export const CREATE_GAME_LOADING = "CREATE_GAME_LOADING"
export const GET_GAME_THEME_CONFIG = "GET_GAME_THEME_CONFIG"
export const SAVE_GAME_CONFIG = "SAVE_GAME_CONFIG"
export const GAME_CONFIG_TO_INITIAL = "GAME_CONFIG_TO_INITIAL"
export const SAVE_GAME_CONFIG_SUCCESS = "SAVE_GAME_CONFIG_SUCCESS"
export const CLEAR_REQUEST_SAVE_GAME = "CLEAR_REQUEST_SAVE_GAME"
export const CAMPAING_COUPON_LIST_REQUEST = "CAMPAING_COUPON_LIST_REQUEST"